export const init = (payload) => {
  const {
    id,
    dateCreated,
    description,
    numberOfChoices,
    dateOfAnnouncement,
    dateOfLocking,
    dateOfCancellation,
    dateTimeVotingStart,
    dateTimeVotingEnd,
    reasonForCancellation,
    cancellationFileUrl,
    cancellationFilePath,
    statusId,
    electionTypeId,
    electionType,
    status,
    candidates,
    multipleChoice,
    cancellationFile,
    location,
    generatedStatus,
    documents,
  } = payload;

  return {
    id,
    dateCreated,
    description,
    numberOfChoices,
    dateOfAnnouncement,
    dateOfLocking,
    dateOfCancellation,
    dateTimeVotingStart,
    dateTimeVotingEnd,
    reasonForCancellation,
    cancellationFileUrl,
    cancellationFilePath,
    statusId,
    electionTypeId,
    electionType,
    status,
    candidates,
    multipleChoice,
    cancellationFile,
    location,
    generatedStatus,
    documents,
  };
};

export const reducer = (state, action) => {
  switch (action.type) {
    case "init":
      return init(action.payload);

    case "update":
      // console.log("UseReducer - update");
      // console.log(action.payload, "action.payload")
      return { ...state, ...action.payload };

    case "addCandidate":
      let candidates = [];
      if (state.candidates?.length > 0) {
        candidates = Array.from(state.candidates);
      }
      candidates.push(action.payload);
      return { ...state, candidates };

    // Always 1 file in Cancellation File array
    case "addCancellationFile":
      let cancellationFile = [];
      cancellationFile.push(action.payload);
      return { ...state, cancellationFile };

    case "addCandidateDocs":
      let documents = [];
      if (state.documents?.length > 0) {
        documents = Array.from(state.documents);
      }
      documents.push(action.payload);
      return { ...state, documents };

    case "addCandidateDocsEdit":
      let editCandidateDocuments = [];
      if (state.editCandidateDocuments?.length > 0) {
        editCandidateDocuments = Array.from(state.editCandidateDocuments);
      }
      editCandidateDocuments.push(action.payload);
      return { ...state, editCandidateDocuments };

    default:
      return { state };
  }
};
